module.exports = __webpack_public_path__ + "img/milbus.70252a37.png";